import React from 'react';

function Footer() {
  // If state has user add padding to bottom

  const year = new Date().getFullYear();

  const styleForOfflineReferral: React.CSSProperties = window.kbSchema.is_offline_referral ? {
    bottom: 0,
    position: 'fixed',
    width: '100%',
  } : {};

  return (
    <footer className="footer footer--main v2-footer" style={styleForOfflineReferral}>
      <div className="container">
        <div className="v2-footer__inner d-flex justify-content-between">
          <img className="v2-footer__logo" alt="logo" src="/images/light-logo-rebranded.svg" />
          <ul className="links list-group list-group-horizontal  align-content-center flex-wrap">
            <li>
              <a href="/terms_and_conditions.html" target="_blank" className="">Terms &amp; Conditions</a>
            </li>
          </ul>
        </div>
        <hr />
        <div className="v2-footer__terms d-flex justify-content-end">
          <span className="terms">
            ©
            {year}
            {' '}
            Kingsbridge Contractor Insurance All Rights Reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
